export var ChainId;
(function (ChainId) {
    ChainId[ChainId["ETH"] = 1] = "ETH";
    ChainId[ChainId["OPTIMISM"] = 10] = "OPTIMISM";
    ChainId[ChainId["CRONOS"] = 25] = "CRONOS";
    ChainId[ChainId["BSC"] = 56] = "BSC";
    ChainId[ChainId["POLYGON"] = 137] = "POLYGON";
    ChainId[ChainId["FANTOM"] = 250] = "FANTOM";
    ChainId[ChainId["BOBA"] = 288] = "BOBA";
    ChainId[ChainId["METIS"] = 1088] = "METIS";
    ChainId[ChainId["MOONBEAM"] = 1284] = "MOONBEAM";
    ChainId[ChainId["MOONRIVER"] = 1285] = "MOONRIVER";
    ChainId[ChainId["ARBITRUM"] = 42161] = "ARBITRUM";
    ChainId[ChainId["AVALANCHE"] = 43114] = "AVALANCHE";
    ChainId[ChainId["AURORA"] = 1313161554] = "AURORA";
    ChainId[ChainId["HARMONY"] = 1666600000] = "HARMONY";
})(ChainId || (ChainId = {}));
export const supportedChainIds = () => Object.keys(ChainId)
    .map(k => Number.isNaN(Number(k)) ? null : Number(k))
    .filter(c => c !== null);
